import { render, staticRenderFns } from "./ModuleCardLast.vue?vue&type=template&id=4f82e5df&"
import script from "./ModuleCardLast.vue?vue&type=script&lang=js&"
export * from "./ModuleCardLast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
